var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "td",
    { staticClass: "td-region" },
    [
      !!_vm.order.params.geo
        ? [
            _vm._v("\n\t\t" + _vm._s(_vm.order.params.geo.region.name_ru)),
            _c("br"),
            _vm.order.params.geo.region.name_ru !=
            _vm.order.params.geo.city.name_ru
              ? [_vm._v(_vm._s(_vm.order.params.geo.city.name_ru))]
              : _vm._e(),
            _vm._v(" "),
            !!_vm.order.params.timezone
              ? [
                  _vm._v(
                    "(GTM " +
                      _vm._s(
                        _vm.order.params.timezone > 0
                          ? "+" + _vm.order.params.timezone
                          : _vm.order.params.timezone
                      ) +
                      ")"
                  )
                ]
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b7a3358", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b7a3358","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/backend/components/table/fields/RegionField.vue
// module id = 174
// module chunks = 1